import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const FooterContainer = styled.div`
  display: none;

  position: absolute;
  bottom: 0;
  left: 0; right: 0;
`;
const Copyright = styled.span`
  display: block;
  padding-bottom: 1em;

  font-family: 'Euclid Square';
  font-weight: 300;
  font-size: .6em;
  text-align: center;
`;

const Footer = ({ siteTitle }) => (
  <FooterContainer>
    <Copyright>florian nebenfuehr © 2018</Copyright>
  </FooterContainer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js